import { ButtonGroup } from 'components/ButtonGroup';
import { ICONS } from 'components/Icon';
import { IconButton } from 'components/IconButton';
import { useConfirm } from 'hooks/useConfirm';
import React from 'react';
import { Platform, StyleProp, ViewStyle } from 'react-native';
import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { FileSourceType } from 'service/file/types';
import { DO_IMAGE_SELECT } from 'store/actions';

interface Props {
  style?: StyleProp<ViewStyle>;
  enableRemoveButton?: boolean;
  action: AnyAction;
  removeConfirmMessage?: string;
}

export const ImageButtons: React.FC<Props> = ({
  action,
  enableRemoveButton = false,
  removeConfirmMessage = 'Do you want to remove this image?',
  style,
}) => {
  const dispatch = useDispatch();
  const confirm = useConfirm();

  const handleQuickAdd =
    (source: FileSourceType.CAMERA | FileSourceType.IMAGE) => () =>
      dispatch(
        DO_IMAGE_SELECT({
          action,
          source,
        }),
      );

  const handleRemoveFiles = () => {
    confirm({
      confirmText: 'Remove',
      destructive: true,
      onConfirm: () =>
        dispatch({ ...action, payload: { ...action.payload, image: null } }),
      text: removeConfirmMessage,
    });
  };

  const buttonChildren = [];

  if (Platform.OS !== 'web') {
    buttonChildren.push(
      <IconButton
        key="camera"
        icon={ICONS.CameraLight}
        onPress={handleQuickAdd(FileSourceType.CAMERA)}
      />,
      <IconButton
        key="image"
        icon={ICONS.ImageLight}
        onPress={handleQuickAdd(FileSourceType.IMAGE)}
      />,
    );
  } else {
    buttonChildren.push(
      <IconButton
        key="image"
        icon={ICONS.ImageLight}
        onPress={handleQuickAdd(FileSourceType.IMAGE)}
      />,
    );
  }

  if (enableRemoveButton) {
    buttonChildren.push(
      <IconButton
        key="remove"
        onPress={handleRemoveFiles}
        icon={ICONS.TrashCanLight}
      />,
    );
  }

  return <ButtonGroup style={style}>{buttonChildren}</ButtonGroup>;
};
